//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  events,
  DirUtil,
  PersonalOfferStorageService,
  StoreFrontSponsorStorageService,
  ShoppingContext,
  UrlService
} from "@nuskin/ns-util";
import { MarketHeaderService } from "@nuskin/ns-product";
import { NsIcon } from "@nuskin/design-components";
import { MySiteRestService } from "@nuskin/my-site-api";
import { isNullOrEmpty, fromJsonString } from "@nuskin/ns-common-lib";

import NsHeaderLegalLinks from "./NsHeaderLegalLinks.vue";
import NsHeaderMarketingMessage from "./NsHeaderMarketingMessage.vue";
import NsHeaderRegionSelector from "./NsHeaderRegionSelector.vue";
import NsHeaderLoyaltyRewards from "./NsHeaderLoyaltyRewards.vue";
import NsHeaderProfileDropdown from "./NsHeaderProfileDropdown.vue";
import NsHeaderProfileDropdownMobile from "./NsHeaderProfileDropdownMobile.vue";
import NsLogo from "./NsLogo.vue";
import NsMiniCart from "./NsMiniCart.vue";
import NsSearchbar from "./NsSearchbar.vue";
import NsTopnav from "./NsTopnav.vue";
import NsDrawer from "./NsDrawer.vue";
import NsHeaderDrawer from "./NsHeaderDrawer.vue";
import NsSearchResults from "./NsSearchResults.vue";
import vueEventBus from "./EventBus";

const DESKTOP_MAX_MARKETING_LENGTH = 100;

export default {
  name: "NsHeaderAem",
  components: {
    NsIcon,
    NsHeaderLegalLinks,
    NsHeaderMarketingMessage,
    NsHeaderRegionSelector,
    NsHeaderLoyaltyRewards,
    NsHeaderProfileDropdown,
    NsHeaderProfileDropdownMobile,
    NsLogo,
    NsMiniCart,
    NsSearchbar,
    NsTopnav,
    NsDrawer,
    NsHeaderDrawer,
    NsSearchResults
  },
  // props will override the data from marketHeaderService
  props: {
    /**
     * Allows you to set the image for the header (distributor profile image).
     * You must also set either hrefOverride (can be done in the service) or logoUrl for this to show
     */
    distributorImage: {
      type: String,
      default: ""
    },
    /**
     * Hides the cart
     */
    hideCart: Boolean,
    /**
     * Hides the entire header
     */
    hideHeader: Boolean,
    /**
     * Hides the top left section
     */
    hideTopLeft: Boolean,
    /**
     * Hides the bottom left section
     */
    hideBottomLeft: Boolean,
    /**
     * Hides the top right section
     */
    hideTopRight: Boolean,
    /**
     * Hides the bottom right section
     */
    hideBottomRight: Boolean,
    /**
     * Hides the bottom center section
     */
    hideBottomCenter: Boolean,
    /**
     * Hides the top center section
     */
    hideTopCenter: Boolean,
    /**
     * Hides profile component (Sign Up/Sign In)
     */
    hideProfile: Boolean,
    /**
     * Hides the search bar
     */
    hideSearchbar: Boolean,
    /**
     * Hides everything in the utility bar
     */
    hideUtilityBar: Boolean,
    /**
     * Hides the legal links
     */
    hideLegalLinks: Boolean,
    /**
     * Hides the marketing message
     */
    hideMarketingMessage: Boolean,
    /**
     * Hides the region selector
     */
    hideRegionSelector: Boolean,
    /**
     * Hides the menu
     */
    hideMenu: Boolean,
    /**
     * Hides the logo
     */
    hideLogo: Boolean,
    /**
     * Hides the top navigation
     */
    hideTopNav: Boolean,
    /**
     * Hides loyalty
     */
    hideLoyalty: Boolean,
    /**
     * Hides Join Us
     */
    hideJoinUs: Boolean,
    /**
     * Hides Sign Up
     */
    hideSignUp: Boolean,
    /**
     * If set, this will override the page redirect on the region selector page and the distributor logo (and logout redirect)
     */
    hrefOverride: {
      type: String,
      default: ""
    },
    /**
     * Allows you to set the id for the header component
     */
    id: {
      type: String,
      default: ""
    },
    /**
     * Boolean for if menu is open, toggles state of other elements accordingly
     */
    isMenuOpen: Boolean,
    /**
     * Translation and link for Join Us link
     */
    joinUs: {
      type: [Object, String],
      default: null
    },
    /**
     * Link for UsableNet accessibility
     */
    accessibilityLink: {
      type: [Object, String],
      default: null
    },
    /**
     * Array of links to display in the top utility bar: left
     * Objects in array require 'href' and 'name'
     */
    legalLinks: {
      type: [Array, String],
      default: null
    },
    /**
     * Set the URL that you are redirected to when clicking on the header/distributor logo
     */
    logoUrl: {
      type: String,
      default: ""
    },
    /**
     * Sets information in the top utility bar: center
     * Object requires 'info', 'href', and 'link'
     */
    marketingMessage: {
      type: [Object, String],
      default: null
    },
    /**
     * Used in conjunction with useHeaderService, setting this to true
     * will make the service return data for a My Site header (storefront, personal offer).
     */
    mysite: Boolean,
    /**
     * Used to force the component to ignore My Site header data.
     */
    noMysite: Boolean,
    /**
     * Navigation array for the mega dropdown
     */
    navigation: {
      type: [Array, String],
      default: null
    },
    /**
     * Array of menu items for the profile component
     */
    profileMenu: {
      type: [Array, String],
      default: null
    },
    /**
     * Translations for the profile
     */
    profileTranslations: {
      type: [Object, String],
      default: null
    },
    /**
     * Region
     */
    region: {
      type: [Object, String],
      default: null
    },
    /**
     * Allows you to set where the select other region redirects too
     */
    regionSelectorPath: {
      type: String,
      default: ""
    },
    /**
     * If set, this will only show regions according to what is in the array
     * [ "en_US", "es_US" ]
     */
    regionsAllowed: {
      type: String,
      default: ""
    },
    /**
     * Translations for the search results
     */
    searchResultsTranslations: {
      type: [Object, String],
      default: null
    },
    /**
     * Where to redirect after signing out
     */
    signOutUrl: {
      type: String,
      default: ""
    },
    /**
     * Toggles theme styles and functionality
     */
    theme: {
      type: String,
      default: "auto"
    },
    /**
     * Translations for the header
     * Options: 'selectOther'
     */
    translations: {
      type: [Object, String],
      default: null
    },
    /**
     * Don't use the AEM service to pull all the information needed to use the header
     */
    noHeaderService: Boolean,
    /**
     * Allows tabs for mega dropdown to be clickable to top-level category pages
     * Should only be used for dev purposes, as it is incompatible with touch
     * devices
     */
    useTopLevelNav: Boolean,
    /**
     * use a market override for the logo url source for <NsLogo> in the header
     *   reference the computed prop marketOverrideCondition
     *   if marketOverrideCondition resolves to true, assign the props `:market-logo-mobile-url`
     *   and `:market-logo-desktop-url` given to <NsLogo/> to be the market override logo source urls
     */
    logoUrlMarketOverride: {
      type: Boolean,
      default: false
    },
    /**
     * For disabling href link on logo
     */
    disableLogoLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logoData: {},
      marketData: {},
      miniCartData: {},
      mobileDrawerOpen: false,
      profileData: {},
      searchResultsPageData: {},
      searchbarData: {},
      truncateTextOnSmallestBreakpoint: false,
      showMobileMarketingMessage: true,
      showSearchResults: false,
      hideLegalLinksEvent: false,
      hideSearchbarEvent: false,
      hideTopNavEvent: false,
      hideMenuEvent: false
    };
  },
  computed: {
    desktop() {
      return this.$mq === "desktop" || this.$mq === "desktopHD";
    },
    market() {
      return (
        this.$NsAppService.runConfig.market ||
        this.$NsAppService.runConfig.country ||
        ""
      );
    },
    language() {
      return this.$NsAppService.runConfig.language || "";
    },
    locale() {
      return this.$NsAppService.locale || "";
    },
    baseUrl() {
      return this.$NsAppService.runConfig.baseUrl || "";
    },
    isStorefront() {
      return !!this.$NsAppService.isStorefront;
    },
    useMysiteHeader() {
      return !this.noMysite && (this.isStorefront || this.mysite);
    },
    // noHeaderService must be true if you want to pass props manually instead
    header() {
      return {
        //The URL for a distributor profile image that is shown in place of the NS Logo
        distributorImage:
          this.distributorImage ||
          this.logoData.distributorImage ||
          this.marketData.distributorImage ||
          "",
        // marketData
        hideHeader:
          this.hideHeader || this.hidden || this.marketData.hideHeader || false,
        hideTopLeft:
          this.hideTopLeft || this.marketData.hideHeaderTopLeft || false,
        hideTopCenter:
          this.hideTopCenter || this.marketData.hideHeaderTopCenter || false,
        hideTopRight:
          this.hideTopRight || this.marketData.hideHeaderTopRight || false,
        hideBottomLeft:
          this.hideBottomLeft || this.marketData.hideHeaderBottomLeft || false,
        hideBottomCenter:
          this.hideBottomCenter ||
          this.marketData.hideHeaderBottomCenter ||
          false,
        hideBottomRight:
          this.hideBottomRight ||
          this.marketData.hideHeaderBottomRight ||
          false,
        hideProfile: this.hideProfile || this.marketData.hideMyAccount || false,
        hideSearchBar:
          this.hideSearchbar ||
          this.hideSearchbarEvent ||
          this.marketData.hideSearchBar ||
          false,
        hideUtilityBar:
          this.hideUtilityBar || this.marketData.hideUtilityBar || false,
        hideLegalLinks:
          this.hideLegalLinks ||
          this.hideLegalLinksEvent ||
          this.marketData.hideLegalLinks ||
          false,
        hideMarketingMessage:
          this.hideMarketingMessage ||
          this.marketData.hideMarketingMessage ||
          false,
        hideRegionSelector:
          this.hideRegionSelector ||
          this.marketData.hideRegionSelector ||
          false,
        hideMenu:
          this.hideMenu ||
          this.hideMenuEvent ||
          this.marketData.hideMenu ||
          false,
        hideLogo: this.hideLogo || this.marketData.hideLogo || false,
        hideTopNav:
          this.hideTopNav ||
          this.hideTopNavEvent ||
          this.marketData.hideTopNav ||
          false,
        hideLoyalty: this.hideLoyalty || this.marketData.hideLoyalty || false,
        hideJoinUs: this.hideJoinUs || this.marketData.hideJoinUs || false,
        hideCart: this.hideCart || this.marketData.hideShoppingBag || false,
        hideSignUp: this.hideSignUp || this.profileData.hideSignUp || false,
        headerType: this.marketData.headerType || "default",
        homeUrl:
          this.hrefOverride ||
          this.logoUrl ||
          this.logoData.linkUrl ||
          this.marketData.hrefOverride ||
          "",
        mySiteLabel: this.marketData.tdc_mySite || "",
        id: this.id || this.marketData.id || "ns-header",
        joinUs: this.j(this.joinUs) ||
          this.marketData.joinUs || {
            label: "Join",
            link: "/join.html"
          },
        accessibilityLink: this.j(this.accessibilityLink) ||
          this.marketData.accessibility || {
            showAccessibilityLink: false,
            accessibilityActivate: "Activate Accessibility",
            accessibilityDeactivate: "Turn Off Accessibility",
            accessibilityHref: "#",
            accessibilityStyle: "UsableNetAssistive",
            accessibilityOnclick: "return enableUsableNetAssistive()"
          },
        legalLinks: this.j(this.legalLinks) || this.marketData.legalLinks || [],
        marketingMessage: this.j(this.marketingMessage) ||
          this.marketData.marketingMessage || {
            info: "",
            href: "",
            link: ""
          },
        navigation:
          this.j(this.navigation) ||
          this.removeHTTPSPub(this.marketData.navigation) ||
          [],
        region: this.j(this.region) || this.marketData.region || {},
        regionSelectorPath:
          this.j(this.regionSelectorPath) ||
          this.marketData.regionSelectorPath ||
          "/content/nuskin.html#region-selection",
        translations: this.j(this.translations) ||
          this.marketData.translations || {
            selectOther: "Select Other",
            enjoyLoyalty: "Enjoy Rewards"
          },
        useNewHeader:
          this.useNewHeader || this.marketData.useNewHeader || false,
        useNewTopNav:
          this.useNewTopNav || this.marketData.useNewTopNav || false,
        // miniCartData
        cartText: this.miniCartData.shoppingBagText || "",
        showCartText: this.miniCartData.showShoppingBagText || false,
        // profile
        profileTranslations: (() => {
          const translations =
            this.j(this.profileTranslations) ||
            this.profileData.translations ||
            {};
          return {
            ...translations,
            enjoyLoyalty:
              this.marketData &&
              this.marketData.translations &&
              this.marketData.translations.enjoyLoyalty
                ? this.marketData.translations.enjoyLoyalty
                : "Enjoy Rewards",
            signIn: (translations.signIn && translations.signIn.name) || "",
            signOut: (translations.signOut && translations.signOut.name) || ""
          };
        })(),
        profileMenu:
          this.j(this.profileMenu) || this.profileData.profileMenu || [],
        newCustomerLabel:
          (
            this.j(this.profileTranslations) ||
            this.profileData.translations ||
            {}
          ).newCustomerLabel || "",
        signUpTodayLabel:
          (
            this.j(this.profileTranslations) ||
            this.profileData.translations ||
            {}
          ).signUpTodayLabel || "",
        signOutUrl: (() => {
          if (this.signOutUrl) {
            return this.signOutUrl;
          } else {
            const translations =
              this.j(this.profileTranslations) ||
              this.profileData.translations ||
              {};
            return (translations.signOut && translations.signOut.href) || "";
          }
        })(),
        signUpUrl: this.profileData.signUpUrl || "",
        // searchbar
        disablePredictiveSearch:
          this.searchbarData.disablePredictiveSearch || false,
        searchbarTranslations: this.searchbarData.translations || {},
        popularSearchArray: this.searchbarData.popularSearchArray || [],
        hideSeeMoreResults: this.searchbarData.hideSeeMoreResults || false,
        showToolTip: this.searchbarData.showToolTip || false,
        orderTypeInPredictive:
          this.searchbarData.orderTypeInPredictive || false,
        searchOptions: this.searchbarData.searchOptions || {},
        // search results
        searchResultsTranslations:
          this.j(this.searchResultsTranslations) ||
          this.searchResultsPageData.translations ||
          {},
        // storefront
        regionsAllowed:
          this.j(this.regionsAllowed) || this.marketData.regionsAllowed || [],
        showDistributorImage:
          this.distributorImage ||
          this.logoData.showDistributorImage ||
          this.marketData.showDistributorImage ||
          false
      };
    },
    isHeaderDataMysite() {
      return this.header.headerType === "nsHeaderStoreFront";
    },
    dir() {
      return DirUtil.getDir();
    },
    utilityBarCenterClass() {
      const { info = "", link = "" } = this.header.marketingMessage || {};

      if (this.header.marketingMessage) {
        return info.length + link.length > DESKTOP_MAX_MARKETING_LENGTH
          ? "unlock-center"
          : "";
      } else {
        return "";
      }
    },
    urlPrefix() {
      return (
        (this.market.toLowerCase() === "jp"
          ? "/content/markets/"
          : "/content/nuskin/") +
        this.language +
        "_" +
        this.market +
        "/"
      );
    },
    marketOverrideCondition() {
      // this market override is assigned as true for the japan market until October 1, 2023.
      // we can update this for a new market condition afterwards, or delete it.
      const now = new Date();
      const changeDate = new Date("October 1, 2023");
      let returnValue =
        (this.market.toLowerCase() === "jp" && now < changeDate) ||
        this.logoUrlMarketOverride;
      return returnValue;
    }
  },
  watch: {
    useMysiteHeader(useMysiteHeader) {
      if (
        useMysiteHeader !== this.isHeaderDataMysite ||
        !this.marketData.headerType
      ) {
        this.getPropsFromAjax();
      }
    }
  },
  async created() {
    this.updateForMySite();
  },
  async mounted() {
    this.addListeners();

    // navigating from personal offer to the home page in same window
    // ensures correct header is shown under these conditions
    if (
      this.header.headerType === "default" &&
      (this.useMysiteHeader || this.isStorefront || this.mysite) &&
      !window.location.href.includes("mysite")
    ) {
      this.getPropsFromAjax();
    }

    if (window.matchMedia("(max-width: 375px)").matches) {
      this.truncateTextOnSmallestBreakpoint = true;
    }
  },
  destroyed() {
    this.removeListeners();

    if (document.body.style.position === "fixed") {
      this.unlockBody();
    }
  },
  methods: {
    closeMarketingMessage() {
      this.showMobileMarketingMessage = false;
    },

    async getPropsFromAjax() {
      if (this.noHeaderService) {
        return;
      }

      let page = window.location.pathname.replace("#/", "");
      if (!page.includes(this.locale)) {
        page = "/content/";
        if (this.market.toLowerCase() === "jp") {
          page += "markets";
        } else {
          page += "nuskin";
        }
        page += `/${this.locale}/home.html`;
      } else {
        // Make sure JP is using content/markets path and not just /markets
        page =
          page.indexOf("content/markets/") > -1
            ? page
            : page.replace("/markets/", "/content/markets/");
      }

      const siteUrl = window.location.origin.startsWith("http://localhost")
        ? this.baseUrl || "https://test.nuskin.com"
        : window.location.origin;

      // remove mysite selector if not STOREFRONT context
      if (!this.isStorefront) {
        page = page.replace(".mysite.", ".");
      }
      const headerData = await MarketHeaderService.getMarketHeaderData(
        page,
        siteUrl,
        this.useMysiteHeader
      );

      if (isNullOrEmpty(this.logoData)) {
        this.logoData = headerData.logo || {};
      }

      this.marketData = headerData.market || {};
      this.miniCartData = headerData.miniCart || {};
      this.profileData = headerData.profile || {};
      this.searchResultsPageData = headerData.searchResultsPage || {};
      this.searchbarData = headerData.searchbar || {};
    },

    async updateForMySite() {
      if (this.isStorefront) {
        let storefrontSponsor = StoreFrontSponsorStorageService.getStoreFrontSponsor();
        let sponsorId = null;
        try {
          sponsorId = await MySiteRestService.getCurrentSponsorId();
        } catch {
          sponsorId = null;
        }
        // adjust for My Site
        if (sponsorId) {
          const subdomain = await MySiteRestService.getCurrentSubdomain();
          storefrontSponsor =
            StoreFrontSponsorStorageService.getStoreFrontSponsor() ||
            (await MySiteRestService.getSponsorData(sponsorId));

          if (
            ShoppingContext &&
            ShoppingContext.isContext(ShoppingContext.STOREFRONT)
          ) {
            this.logoData.linkUrl = `${UrlService.getAemLocaleUrl()}mysite/mysite-home.mysite.${subdomain}.html?storeId=${sponsorId}`;
          }

          this.logoData.showDistributorImage = !!storefrontSponsor;
          this.logoData.distributorImage = storefrontSponsor
            ? storefrontSponsor.siteLogo || storefrontSponsor.photoURL
            : `${UrlService.getAemLocaleUrl()}/content/dam/icons/logos/ns-logo.png`;

          const market = this.market.toUpperCase();
          try {
            if (
              storefrontSponsor &&
              storefrontSponsor.storefront &&
              storefrontSponsor.storefront[subdomain] &&
              storefrontSponsor.storefront[subdomain][market] &&
              storefrontSponsor.storefront[subdomain][market].lang &&
              storefrontSponsor.storefront[subdomain][market].lang[
                this.language
              ]
            ) {
              const hideSearchAndNav = !storefrontSponsor.storefront[subdomain][
                market
              ].lang[this.language].fullProductCatalog;
              if (hideSearchAndNav) {
                this.hideSearchbarEvent = true;
                this.hideTopNavEvent = true;
              }
            }
          } catch (ex) {
            console.error(ex);
          }
        }
        // adjust for Vera
        if (ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT)) {
          this.logoData.linkUrl = `${this.baseUrl}/static/skin-consultation/#/${
            this.language
          }_${this.market.toUpperCase()}/recommendations`;
        }
        // adjust for Personal Offer
        if (PersonalOfferStorageService.isPersonalOffer()) {
          const personalOffer = PersonalOfferStorageService.getPersonalOffer();
          const picURL =
            personalOffer.profilePhoto || personalOffer.photoUrl
              ? personalOffer.profilePhoto || personalOffer.photoUrl
              : `${this.baseUrl}/content/dam/icons/logos/ns-logo.png`;
          this.logoData.linkUrl = personalOffer.landingPageURL;
          this.logoData.showDistributorImage = !!storefrontSponsor;
          this.logoData.distributorImage = storefrontSponsor
            ? storefrontSponsor.profilePhoto || storefrontSponsor.photoURL
            : picURL;

          this.hideSearchbarEvent = true;
          this.hideTopNavEvent = true;
          this.hideLegalLinksEvent = true;
        }
      } else {
        this.logoData = {};
      }
    },

    getOffSetHeight() {
      const domHeader = document.querySelector("#" + this.header.id);
      return domHeader ? domHeader.offsetHeight : 0;
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      window.addEventListener("resize", this.handleWindowResize);

      this.$watch(
        function() {
          return !this.$NsAppService.loading;
        },
        this.getPropsFromAjax,
        {
          immediate: true
        }
      );

      events.subscribe(
        events.global.RUN_CONFIG_CHANGED,
        this.$NsAppService.checkConfig
      );

      vueEventBus.$on("config-changed", this.handleConfigChanged);
      events.subscribe("updateHeaderLanguage", this.handleConfigChanged);

      events.subscribe(events.shop.SEARCH_EXECUTED, this.handleSearchExecuted);

      events.subscribe(
        events.header ? events.header.HIDE_SEARCHBAR : "headerHideSearchbar",
        this.handleHideHeaderSearchbar
      );

      events.subscribe(
        events.header ? events.header.HIDE_NAVIGATION : "headerHideNavigation",
        this.handleHideHeaderNavigation
      );

      events.subscribe(
        events.header
          ? events.header.SET_DISTRIBUTOR_IMAGE
          : "headerSetDistributorImage",
        this.handleSetDistributorImage
      );

      events.subscribe(
        events.header ? events.header.HIDE_MENU : "headerHideMenu",
        this.handleHideHeaderMenu
      );

      events.subscribe(
        events.header ? events.header.SET_LOGO_HREF : "headerSetLogoHref",
        this.handleSetHeaderLogoHref
      );

      events.subscribe(
        events.header
          ? events.header.SET_HREF_OVERRIDE
          : "headerSetHrefOverride",
        this.handleSetHeaderHrefOverride
      );
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      window.removeEventListener("resize", this.handleWindowResize);

      events.unsubscribe(
        events.global.RUN_CONFIG_CHANGED,
        this.$NsAppService.checkConfig
      );

      vueEventBus.$off();
      events.unsubscribe("updateHeaderLanguage", this.handleConfigChanged);

      events.unsubscribe(
        events.shop.SEARCH_EXECUTED,
        this.handleSearchExecuted
      );

      events.unsubscribe(
        events.header ? events.header.HIDE_SEARCHBAR : "headerHideSearchbar",
        this.handleHideHeaderSearchbar
      );

      events.unsubscribe(
        events.header ? events.header.HIDE_NAVIGATION : "headerHideNavigation",
        this.handleHideHeaderNavigation
      );

      events.unsubscribe(
        events.header
          ? events.header.SET_DISTRIBUTOR_IMAGE
          : "headerSetDistributorImage",
        this.handleSetDistributorImage
      );

      events.unsubscribe(
        events.header ? events.header.HIDE_MENU : "headerHideMenu",
        this.handleHideHeaderMenu
      );

      events.unsubscribe(
        events.header ? events.header.SET_LOGO_HREF : "headerSetLogoHref",
        this.handleSetHeaderLogoHref
      );

      events.unsubscribe(
        events.header
          ? events.header.SET_HREF_OVERRIDE
          : "headerSetHrefOverride",
        this.handleSetHeaderHrefOverride
      );
    },

    toggleMenu() {
      this.mobileDrawerOpen = !this.mobileDrawerOpen;
      events.publish("toggleDrawer");
    },

    scrollToTopOfSearchResults() {
      this.$refs.searchResults.scrollTop = 0;
    },

    lockBody() {
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = "fixed";
    },

    unlockBody() {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    },

    handleConfigChanged() {
      this.getPropsFromAjax();
      this.updateForMySite();
    },

    handleWindowResize() {
      setTimeout(() => {
        let offsetHeight = this.getOffSetHeight();
        document.documentElement.style.setProperty(
          "--header-height",
          `${offsetHeight}px`
        );
      }, 1);
    },

    handleSearchExecuted(searchObject) {
      this.showSearchResults =
        !!searchObject && !!searchObject.showSearchResults;

      if (this.showSearchResults) {
        this.lockBody();
      } else {
        this.unlockBody();
      }
    },

    handleBackButtonClicked() {
      this.$refs.searchbar.clearSearch();
    },

    handleCloseSearchResults() {
      this.showSearchResults = false;
      this.unlockBody();
    },

    handleHideHeaderSearchbar(hide) {
      this.hideSearchbarEvent = !!hide;
    },

    handleHideHeaderNavigation(hide) {
      this.hideTopNavEvent = !!hide;
    },

    handleSetDistributorImage(imageData) {
      if (imageData.url && imageData.url.length > 0) {
        if (imageData.hrefOverride) {
          if (
            imageData.aemSource &&
            imageData.hrefOverride.indexOf(this.urlPrefix) == -1
          ) {
            this.logoData.linkUrl =
              this.urlPrefix +
              (imageData.hrefOverride.indexOf("/") == 0
                ? imageData.hrefOverride.substr(1)
                : imageData.hrefOverride);
          } else {
            this.logoData.linkUrl = imageData.hrefOverride;
          }
          //Force the DOM to re-draw if the hrefOverride wasn't there (making the img hidden)
          // if (!this.hrefOverride) {
          //   this.hrefOverride = this.logoData.linkUrl;
          //   this.hrefOverride = "";
          // }
        }
        this.logoData.showDistributorImage = true;
        this.logoData.distributorImage = imageData.url;
      }
    },

    handleHideHeaderMenu(hide) {
      this.hideMenuEvent = !!hide;
    },

    handleSetHeaderLogoHref(logoData) {
      if (logoData && logoData.linkUrl && logoData.linkUrl.length > 0) {
        if (
          logoData.aemSource &&
          logoData.linkUrl.indexOf(this.urlPrefix) == -1
        ) {
          this.logoData.linkUrl =
            this.urlPrefix +
            (logoData.linkUrl.indexOf("/") == 0
              ? logoData.linkUrl.substr(1)
              : logoData.linkUrl);
        } else {
          this.logoData.linkUrl = logoData.linkUrl;
        }
      } // else {
      //   this.logoData.linkUrl = "";
      // }
    },

    handleSetHeaderHrefOverride(overrideData) {
      if (overrideData && overrideData.href && overrideData.href.length > 0) {
        if (
          overrideData.aemSource &&
          overrideData.href.indexOf(this.urlPrefix) == -1
        ) {
          this.logoData.linkUrl =
            this.urlPrefix +
            (overrideData.href.indexOf("/") == 0
              ? overrideData.href.substr(1)
              : overrideData.href);
        } else {
          this.logoData.linkUrl = overrideData.href;
        }
      } // else {
      //   this.logoData.linkUrl = "";
      // }
    },

    // short alias for fromJsonString
    j(s, d) {
      return fromJsonString(s, d);
    },

    removeHTTPSPub(navigation) {
      if (navigation) {
        let topnav = navigation;
        for (let navItem of navigation) {
          for (const [key, value] of Object.entries(navItem)) {
            if (this.wildcardMatch(value, "https://*-pubaws*")) {
              let newval = value;
              if (!this.wildcardMatch(value, "*nuskin.io:*")) {
                newval = newval.replace("nuskin.io", "nuskin.io:4503");
              }
              topnav[key] = newval.replace("https:", "http:");
            }
          }
        }
        return topnav;
      } else {
        return navigation;
      }
    },

    wildcardMatch(str, rule) {
      const escapeRegex = str => str.replace(/([.*+?^=!:${}()|\]\\])/g, "\\$1");
      return new RegExp(
        "^" +
          rule
            .split("*")
            .map(escapeRegex)
            .join(".*") +
          "$"
      ).test(str);
    }
  }
};
